import { OrganizationPermissions_DbKey } from './_entity/organization-permission/index.js';
import { Account_DbKey } from '@nu-art/user-account-shared';
import { DefaultAccessLevel_Read, DefaultAccessLevel_Write, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const DomainNamespace_OrganizationPermissions = 'OrganizationPermissions';
export const OrgPermissionsDependencies = {
    'meta.read': { dbKey: OrganizationPermissions_DbKey, fieldType: 'string[]' },
    'meta.write': { dbKey: OrganizationPermissions_DbKey, fieldType: 'string[]' },
    'meta.createdBy': { dbKey: Account_DbKey, fieldType: 'string' },
};
export const defaultReadAccessLevels_forNewOrgPermission = Object.freeze({
    name: 'read',
    value: DefaultAccessLevel_Read.value
});
export const defaultWriteAccessLevels_forNewOrgPermission = Object.freeze({
    name: 'write',
    value: DefaultAccessLevel_Write.value
});
export const organizationPermissionDefaultLevels = [defaultReadAccessLevels_forNewOrgPermission, defaultWriteAccessLevels_forNewOrgPermission];
export const OrganizationPermissionsPermissionKeys = generateKeyNamesByAccessLevel(DomainNamespace_OrganizationPermissions, organizationPermissionDefaultLevels);
//# sourceMappingURL=consts.js.map